import { useCallback, useEffect, useState } from 'react';
import { message } from 'antd';
import { FIND, FIND_KEY, process } from '../Service/Api';

export const useFetchZipcodes = (queries = '', skip = 0, limit = 10) => {
  const [data, setData] = useState({ data: [] });
  const [loading, setLoading] = useState(false);
  const [params, setParams] = useState({ queries, limit, skip });

  const getZipcodes = useCallback(async () => {
    setLoading(true);
    const response = await process(FIND, 'zipcodes', {}, params);
    if (response?.ok) {
      setData(response.data);
    } else {
      message.error('Error al consultar Usos del CFDI');
    }
    setLoading(false);
  }, [process, params]);

  useEffect(() => {
    getZipcodes();
  }, [getZipcodes]);

  const onChangeParams = (q = '', s = 0, l = 10) =>
    setParams({ queries: q, limit: l, skip: s });

  const update = () => getZipcodes();

  return [data, loading, onChangeParams, update];
};

export const useFetchZipcodesWithApiKey = (
  queries = '',
  skip = 0,
  limit = 10
) => {
  const [data, setData] = useState({ data: [] });
  const [loading, setLoading] = useState(false);
  const [params, setParams] = useState({ queries, limit, skip });

  const getZipcodes = useCallback(async () => {
    setLoading(true);
    const response = await process(FIND_KEY, 'zipcodes', {}, params);
    if (response?.ok) {
      setData(response.data);
    } else {
      message.error('Error al consultar Usos del CFDI');
    }
    setLoading(false);
  }, [process, params]);

  useEffect(() => {
    getZipcodes();
  }, [getZipcodes]);

  const onChangeParams = (q = '', s = 0, l = 10) =>
    setParams({ queries: q, limit: l, skip: s });

  const update = () => getZipcodes();

  return [data, loading, onChangeParams, update];
};
